import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import { scenario9GtubeMedAdmAudioCaching, scenario9GtubeMedAdmVideoSegments } from "../../../scenario9-gtube-med-adm";
import { GtubeMedAdmComponentsStep2ComponentPart1Config, GtubeMedAdmComponentsStep2ComponentMainConfig } from "../gtube-med-adm-components-step2";

export default class GtubeMedAdmComponentsStep2Part1 extends BaseScenarioPart<GameBaseScenario> {

	private stepName="Step 3"
	private get config(): GtubeMedAdmComponentsStep2ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: GtubeMedAdmComponentsStep2ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType2UI({
			audioUrl: scenario9GtubeMedAdmAudioCaching.getItemByKey(scenario9GtubeMedAdmAudioCaching.audioKeys.question5).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: this.stepName,
			isYesCorrect: false,
			correctFeedback: `
				<p class="default-text">Correct. There is no history involving this type of behavior or decision making with this employee.</p>
			`,
			wrongFeedback: `
				<p class="default-text">This is not the best option. Nurse Jamie has not previously been involved in a similar incident.</p>
			`,
			question: 'Were there repetitive occurrences with this type of behavior involving the employee?',
			onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
				const mentorInfo = scenario9GtubeMedAdmVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType2(isCorrect, feedback, selectedTitle, this.stepName, parentQuestion, () => {
					context.section2();
				}, () => {
					context.section2();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[11], mentorInfo.chapterIds[12]);
			}
		}, 4);
	}

	public section2() {
		const context = this;
        this.mainConfig.scenario.setAreaForCurrentScenario(5);
		this.mainConfig.scenario.uiWrapper.displayIntroScreenUI({
			title: 'Re-Cap Summary Statement',
			subtitle: 'Scenario 9 - G-Tube Medication Administration',
			recapFirst: 'In summary this is “Human Error.” ',
			htmlData: `
				<br/><li>The substitution test is satisfied. 
				<br/><br/></li><li>Accountability lies with leadership to analyze system and or cultural issues that may exist. 
				<br/><br/></li><li>There is no history involving this type of behavior from this employee. 
				<br/><br/></li><li>Employee should be consoled. 
				<br/><br/></li><li>Leadership should take steps to correct system and or cultural issues.</li>
			`,
			okButton: 'Continue',
			onStartScenarioClicked: () => {
				context.onDone();
			},
			mentorUrl: scenario9GtubeMedAdmVideoSegments.getItemByKey('Feedback').src,
			mentorChapter: scenario9GtubeMedAdmVideoSegments.getItemByKey('Feedback').chapterIds[14]
		})
	}
}